var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.9646C21 10.6992 20.207 9.61805 19.0874 9.18233C20.1152 8.00859 20.067 6.22927 18.9416 5.11264C17.8056 3.98567 15.9884 3.94726 14.8058 4.99694C14.3939 3.83403 13.2778 3 11.9643 3C10.6507 3 9.5644 3.81187 9.13912 4.95066C7.95556 3.94973 6.177 4.00339 5.05845 5.11313C3.93345 6.22927 3.88531 8.00859 4.91255 9.18282C3.79301 9.61854 3 10.6992 3 11.9646C3 13.2476 3.81484 14.3411 4.9592 14.7645C3.88333 15.9373 3.91657 17.7535 5.05845 18.8869C6.177 19.9966 7.95605 20.0503 9.13912 19.0493C9.5644 20.1881 10.6686 21 11.9643 21C13.26 21 14.3939 20.166 14.8058 19.0026C15.9884 20.0522 17.8056 20.0138 18.9416 18.8869C20.0834 17.754 20.1167 15.9373 19.0408 14.7645C20.1852 14.3411 21 13.2471 21 11.9646Z",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    stroke: "#929292",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.55434baace59e77d72b7f35d0a1acc83.svg";
export { ForwardRef as ReactComponent };